// Lib
import React from 'react';

// Utils
import { chooseSingular, pluralise } from '../../../../common/utils/stringUtil';

type Props = {
    attachmentErrors: string[];
};

const AttachmentErrorContent: React.FC<Props> = ({ attachmentErrors }) => (
    <>
        <h2>
            Can&apos;t upload {chooseSingular(attachmentErrors.length, 'this', 'these')}&nbsp;
            {pluralise('file', attachmentErrors.length)}
        </h2>
        <div className="section">
            <ul className="issues">
                {attachmentErrors.map((errMessage, index) => (
                    <li key={index}>{errMessage}</li>
                ))}
            </ul>
        </div>
    </>
);

export default AttachmentErrorContent;
